export default "__VITE_ASSET__BEmEBxDP__"